import React, { useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import CourseTable from "./CourseTable";
import useAxios from "axios-hooks";
import DeleteCourseModal from "./DeleteCourseModal";
import { Spinner, Toggle } from "@fluentui/react";
import CloneCourseModal from "./CloneCourseModal";
import { useBoolean } from "@fluentui/react-hooks";

const CourseList = () => {
    const [selectedCourseId, setSelectedCourseId] = useState(undefined);
    const [selectedCourseTitle, setSelectedCourseTitle] = useState(undefined);
    const [showRevisions, setShowRevisions] = useState(false);
    const history = useHistory();
    let { url } = useRouteMatch();

    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);
    const [showCloneModal, { toggle: toggleCloneModal }] = useBoolean(false);

    const [{ data: courses, loading }, refetch] = useAxios("courses");

    const [{ revisionLoading }, newRevision] = useAxios({ method: "post" }, { manual: true });

    if (loading)
        return <Spinner className="absolute-center" label="Loading Course..." />;

    return (
        <>
            <Toggle inlineLabel label="Show All Revisions" defaultChecked={showRevisions} onChange={(e, newValue) => setShowRevisions(newValue)} />
            <CourseTable
                key={showRevisions}
                showRevisions={showRevisions}
                courses={(courses || []).filter(c => showRevisions || c.currentCRSRevID === c.crsRevID).sort((a, b) => b.crsid - a.crsid)}
                setSelectedCourseId={setSelectedCourseId}
                selectedCourseId={selectedCourseId}
                setSelectedCourseTitle={setSelectedCourseTitle}
                createOnClick={() => history.push(`${url}/wizard`)}
                cloneOnClick={(id) => {
                    setSelectedCourseId(id);
                    toggleCloneModal()}}
                deleteOnClick={(id) => {
                    setSelectedCourseId(id);
                    setSelectedCourseTitle(courses.find(c => c.crsid === id)?.title);
                    toggleDeleteModal()}}
                editOnClick={(id, revId) => history.push(`${url}/${id}/${revId}/wizard`)}
                refetch={refetch}
                revisionOnClick={async (id) => {
                    var result = await newRevision({ url: `/courses/${id}/new-revision` });
                    history.push(`${url}/${id}/${result.data.revNum}/wizard`);
                }}
                loading={loading || revisionLoading}
            />
            <CloneCourseModal
                courseId={selectedCourseId}
                showModal={showCloneModal}
                toggleShowModal={toggleCloneModal}
            />
            <DeleteCourseModal
                courseId={selectedCourseId}
                courseTitle={selectedCourseTitle}
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
            />
        </>
    );
};

export default CourseList;
